export default __webpack_public_path__ + "static/media/100_38815.f99c7c37.jpg";